/* eslint-disable eqeqeq */

import React, { Component } from 'react';
import { InitISelectBikejs } from '../../modules/Event2';
import { TimeLocale } from '../../modules/Helper';
import { Api } from '../../modules/Service';

class Select2Bikejs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataselect: [],
      loading: true,
    };
  }
  componentDidMount() {
    const { loading } = this.state;
    const { lookup_url } = this.props.config;
    if (loading) {
      Api(lookup_url).done(resp => {
        this.setState({
          dataselect: resp,
          loading: false,
        });
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { dataselect } = this.state;
    const { key } = this.props.config;
    if (dataselect != null) {
      InitISelectBikejs(key);
    }
  }
  render() {
    const { loading, dataselect } = this.state;
    const { config, data, requestBikes } = this.props;
    const {
      label,
      key,
      lookup_key,
      lookup_format,
      required,
      default_value,
    } = config;
    const value = data != null ? data[key] : '';
    // if(requestBikes!=undefined){ var finalArray = requestBikes.concat(dataselect); } else { var finalArray = dataselect;  }
    let requestBikes1 = '';
    if (requestBikes != undefined) {
      requestBikes1 = requestBikes;
    }

    return [
      <label key="0">{label}</label>,
      <select
        key="1"
        name={key}
        id={'select2-' + key}
        data-value={value || default_value}
        required={required}
        className="form-control bikes select2"
        defaultValue=""
      >
        {(() => {
          switch (true) {
            case loading:
              return (
                <option value="" disabled>
                  Loading...
                </option>
              );

            case requestBikes1.length > 0 && dataselect.length > 0:
              const retVal = [];
              retVal.push(
                <option key="0" value="">
                  select item
                </option>,
              );
              retVal.push(<optgroup label="Contract Request Bikes" />);
              retVal.push(
                requestBikes1.map(item => {
                  const opttext = lookup_format.replace(
                    /{(.*?)}/g,
                    ($1, $2) => {
                      if ($2 == 'timestamp') {
                        item[$2] = TimeLocale(item[$2]);
                      }
                      return item[$2] != null ? item[$2] : '-';
                    },
                  );
                  return (
                    <option key={item[lookup_key]} value={item.bike_type_id}>
                      {opttext}
                    </option>
                  );
                }),
              );
              // retVal.push(</optgroup>);

              retVal.push(<optgroup label="All Bikes" />);

              retVal.push(
                dataselect.map(item => {
                  const opttext = lookup_format.replace(
                    /{(.*?)}/g,
                    ($1, $2) => {
                      if ($2 == 'timestamp') {
                        item[$2] = TimeLocale(item[$2]);
                      }
                      return item[$2] != null ? item[$2] : '-';
                    },
                  );
                  return (
                    <option key={item[lookup_key]} value={item[lookup_key]}>
                      {opttext}
                    </option>
                  );
                }),
              );

              return retVal;

            case dataselect.length > 0 && requestBikes1.length < 1:
              const retVal2 = [];
              retVal2.push(
                <option key="0" value="">
                  select item
                </option>,
              );

              retVal2.push(<optgroup label="All Bikes" />);

              retVal2.push(
                dataselect.map(item => {
                  const opttext = lookup_format.replace(
                    /{(.*?)}/g,
                    ($1, $2) => {
                      if ($2 == 'timestamp') {
                        item[$2] = TimeLocale(item[$2]);
                      }
                      return item[$2] != null ? item[$2] : '-';
                    },
                  );
                  return (
                    <option key={item[lookup_key]} value={item[lookup_key]}>
                      {opttext}
                    </option>
                  );
                }),
              );

              return retVal2;

            default:
              return <option value="">Item not found</option>;
          }
        })()}
      </select>,
    ];
  }
}
export default Select2Bikejs;
